export default {
  //ADDRESS: '570 West Fine Drive, Suite E, South Salt Lake City, Utah',
  ADDRESS: '570 W Fine Dr, Ste E, South SLC, UT',
  EMAIL: 'kevin@flowmetalfab.com',
  PHONE: '801-214-8391',
}